import React, { memo } from "react";
import stylesPc from "./VideoInfoPanel.module.css";
import stylesSp from "./VideoInfoPanel_SP.module.css";
import { IsDevice } from "../../../../components/function/useDeviceFlag";
//import { Video } from "../../../../common/video/models/Video";
import { VideoTag } from "../../../../common/video/models/VideoTag";
import Tag from "../../../../common/components/tag/Tag";
import PuiTypography from "../../../../components/elements/PuiTypography";
import PuiTooltip from "../../../../components/elements/PuiTooltip ";
import { useLocation } from "react-router-dom";

interface VideoInfoPanelProps {
    video: any;
}

function VideoInfoPanel({ video }: VideoInfoPanelProps) {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;

    const { pathname } = useLocation();

    return (
        <div className={styles.root}>
            <div className={styles.title} data-tip={video.title} data-for="title">
                {video.title}
            </div>
            <PuiTooltip id={"title"} />
            {/* <div className={styles.countRow}>
                <VideoMetadataLine variant="normal" bold={true} video={video}/> 
            </div> */}

            <div className={styles.createViewerPannel}>
                {!pathname.startsWith("/slidestock") && (
                    <>
                        <div className={styles.playIconArea}>
                            <img
                                src={require("../../../../assets/image/play_connect.svg")}
                                alt="rightIcon"
                            />
                        </div>
                        <div className={styles.viewerCountArea}>
                            <PuiTypography size={17}>{video.viewCount}</PuiTypography>
                        </div>
                        <div className={styles.viewerLableArea}>
                            <PuiTypography size={17}>回視聴・</PuiTypography>
                        </div>
                    </>
                )}
                <PuiTypography size={17}>
                    {video.created.toLocaleDateString("Ja-JP", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                    })}
                </PuiTypography>
            </div>
            {video.tags.length > 0 && (
                <div className={styles.tagList}>
                    {/* <div className={styles.tagListLabel}>
                        <PuiTypography size={14} bold={true} color="gray-61">Tags:</PuiTypography>
                    </div> */}
                    {video.tags.map((tag: VideoTag) => (
                        <Tag key={tag} tag={tag} />
                    ))}
                </div>
            )}
            <div className={styles.description}>
                <PuiTypography>{video.description}</PuiTypography>
            </div>
        </div>
    );
}

export default memo(VideoInfoPanel);
